import React from "react";
import TwoFactorAuthContent from "./TwoFactorAuthContent";
import DashboardLayout from "../../layout/dashboardLayout";

const EditProfile = () => {
  return (
    <DashboardLayout>
      <TwoFactorAuthContent />
    </DashboardLayout>
  );
  // return (
  //   <div className="dashboard_sec">
  //     <div className="container-fluid d-flex px-0 ">
  //       <div className="left_side_sec">
  //         <Sidebar />
  //       </div>
  //       <div className="right_side_sec px-4 py-4">
  //         <Header />
  //         <TwoFactorAuthContent />
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default EditProfile;
